module.exports = __webpack_public_path__ + "static/media/flower7.4b749a65.png";